import { ApiHealthConditionsResponse, ApiMedicalHistoryRequest, ApiMedicalHistoryResponse } from 'src/app/core/models';

const medications = [
  { ndc: '66733-0773-01', name: 'Insulin Lispro' },
  { ndc: '50436-5890-1', name: 'Iron Supplement' },
];

const medicalConditions = ['Diabetes', 'Anemia'];

const allergyConditions = ['Aspirin', 'Codeine', 'Erythromycin', 'Penicillin', 'Sulfa', 'None'];

export const getMedicalHistory = (): ApiMedicalHistoryResponse => ({
  medications,
  medicalConditions,
  allergyConditions,
});

export const getHealthConditions = (): ApiHealthConditionsResponse => {
  return {
    medicalConditions,
    allergyConditions,
  };
};

export const updateMedicalHistory = (_: any, body: ApiMedicalHistoryRequest): ApiMedicalHistoryResponse => ({
  medications: body.medicationNdcs.map((ndc) => ({ ndc, name: ndc })),
  medicalConditions: body.medicalConditions,
  allergyConditions: body.allergyConditions,
});
